class CategoryCarouselComponent extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-carousel-track]');
    this.prevButton = this.querySelector('[data-carousel-prev]');
    this.nextButton = this.querySelector('[data-carousel-next]');

    if (!this.track) return;

    if (this.prevButton) {
      this.prevButton.addEventListener('click', this.handlePrev.bind(this));
    }

    if (this.nextButton) {
      this.nextButton.addEventListener('click', this.handleNext.bind(this));
    }

    this.track.addEventListener('scroll', this.updateArrowStates.bind(this), { passive: true });

    this.updateArrowStates();
  }

  getScrollAmount() {
    const card = this.track.querySelector('[data-carousel-card]');

    if (!card) return 300;

    const style = getComputedStyle(this.track);
    const gap = parseFloat(style.columnGap) || parseFloat(style.gap) || 0;

    return card.offsetWidth + gap;
  }

  handlePrev() {
    const amount = this.getScrollAmount();

    this.track.scrollBy({ left: -amount, behavior: 'smooth' });
  }

  handleNext() {
    const amount = this.getScrollAmount();

    this.track.scrollBy({ left: amount, behavior: 'smooth' });
  }

  updateArrowStates() {
    if (!this.track) return;

    const scrollLeft = Math.round(this.track.scrollLeft);
    const maxScroll = this.track.scrollWidth - this.track.clientWidth;
    const atStart = scrollLeft <= 1;
    const atEnd = scrollLeft >= maxScroll - 1;

    if (this.prevButton) {
      this.prevButton.disabled = atStart;
      this.prevButton.style.opacity = atStart ? '0.5' : '1';
    }

    if (this.nextButton) {
      this.nextButton.disabled = atEnd;
      this.nextButton.style.opacity = atEnd ? '0.5' : '1';
    }
  }
}

customElements.define('category-carousel-component', CategoryCarouselComponent);
